import { IoWarningOutline } from "react-icons/io5";
import { FaPhoneAlt } from "react-icons/fa";
import Button from "./common/Button";
import { STORAGE_KEY } from "../constants";
import { useTranslation } from "react-i18next";
import BookingButton from "./BookingButton";

interface Props {
  message: string;
  isBookingButton?: boolean;
}

const Notification = ({ message, isBookingButton }: Props) => {
  const { t } = useTranslation();

  const config = localStorage.getItem(STORAGE_KEY.CONFIG);
  const { serviceNumber } = config ? JSON.parse(config) : "";

  return (
    <div className="h-[calc(100vh-102px)] flex flex-col">
      <div className="flex-1 space-y-4">
        <IoWarningOutline className=" text-5xl" />
        <h1 className="text-xl font-bold text-gray-800 ">{t("notice_title")}</h1>
        <p className="text-gray-700 ">{message}</p>
        <div className="border-t py-4">
          <p className="text-sm text-gray-500">{t("contact_front_desk")}</p>
        </div>
      </div>

      <div className="flex flex-col gap-3">
        {isBookingButton && <BookingButton />}
        {serviceNumber && (
          <a href={`tel:${serviceNumber}`}>
            <Button>
              <FaPhoneAlt className="mr-2" />
              {t("inquiry")}
            </Button>
          </a>
        )}
      </div>
    </div>
  );
};

export default Notification;
